import React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

import banner0 from '../../../assets/banner-0.png';
import banner2 from '../../../assets/banner-2.png';
import banner3 from '../../../assets/banner-3.jpg';
import banner4 from '../../../assets/banner-4.jpg';

import * as S from './styles';
import { useGlobal } from '../../../contexts/Global/context';

import simulateClick from '../../../utils/simulateClick';

function BannerCarousel() {
    const { dataActiveContract } = useGlobal();
    const params = dataActiveContract.billingRedirectUrls.plinkRend.split('?');

    const images = [
        { img: banner4, url1: 'https://www.gndi.com.br/noticias/planos-de-saude-com-condicoes-especiais-para-empresas-a-partir-de-30-vidas' },
        {
            img: banner0,
            url1: `${process.env.REACT_APP_INCOME_REPORT_DOMAIN}${params[0]}?${params[1]}`,
            url2: `${process.env.REACT_APP_INCOME_REPORT_DOMAIN}/InformeRendimento.aspx?${params[1]}`,
        },
        { img: banner2 },
        { img: banner3 },
    ];

    const treatedImages = images.map((item, index) => (
        <S.BannerBox
            style={{ cursor: index === 0 && 'pointer' }}
            key={index}
            onClick={() => index === 0 && simulateClick(item.url1, item.url2)}
        >
            <img className="banner-border" src={item.img} alt="banners" />
        </S.BannerBox>
    ));
    return (
        <S.CarouselCustom
            interval={6000}
            showThumbs={false}
            showStatus={false}
            showArrows={false}
            autoPlay
            infiniteLoop
            dynamicHeight
        >
            {treatedImages}
        </S.CarouselCustom>
    );
}

export default BannerCarousel;
